import React from "react";
import { inject, observer } from "mobx-react";
import { Variation } from "./variation";
import { VARIATION_TYPES } from "./variationTypesConfig";
import { Card, Select, Tag, Button, Space } from 'antd';
import { DeleteOutlined, PlusOutlined, StarOutlined } from '@ant-design/icons';

@observer
export class VariationsType extends React.Component {
    addVariation = (e) => {
        e.preventDefault();
        const variationsCount = this.props.variationsType.variations.length;
        let previousVariationTags = [];
        if (variationsCount > 0) {
            previousVariationTags = this.props.variationsType.variations[variationsCount - 1].tags;
        }
        const addedVariation = this.props.variationsType.addVariation();
        previousVariationTags.forEach(addedVariation.addTag);
    };

    onDelete = (e) => {
        e.preventDefault();
        this.props.onDelete(this.props.variationsType.id);
    };

    onMakePrimary = (e) => {
        e.preventDefault();
        this.props.onMakePrimary(this.props.variationsType.id);
    };

    onVariationDelete = (id) => this.props.variationsType.removeVariation(id);

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
        }
    };

    render() {
        const { variationsType } = this.props;

        const titleExtra = (
            <Space size={8}>
                {variationsType.isPrimary ? (
                    <Tag color="purple" style={{ margin: 0 }}>Primary</Tag>
                ) : (
                    <Button size="small" icon={<StarOutlined />} onClick={this.onMakePrimary}>
                        Make Primary
                    </Button>
                )}
                <Button
                    icon={<DeleteOutlined />}
                    size="small"
                    danger
                    onClick={this.onDelete}
                />
            </Space>
        );

        const typeTitle = (
            <Select
                size="small"
                value={variationsType.title || undefined}
                placeholder="Choose type…"
                onChange={variationsType.setTitle}
                style={{ width: 180 }}
                options={[
                    { value: '', label: 'Choose…', disabled: true },
                    ...VARIATION_TYPES.map(({ value, label }) => ({ value, label })),
                ]}
            />
        );

        return (
            <Card
                size="small"
                title={typeTitle}
                extra={titleExtra}
                onKeyPress={this.handleKeyPress}
                styles={{ body: { padding: '12px 16px' } }}
            >
                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-start' }}>
                    {variationsType.variations.map(variation => (
                        <Variation
                            key={variation.id}
                            variation={variation}
                            isPrimary={variationsType.isPrimary}
                            onDelete={this.onVariationDelete}
                        />
                    ))}
                    <Button
                        icon={<PlusOutlined />}
                        size="small"
                            onClick={this.addVariation}
                        style={{ alignSelf: 'flex-start', marginTop: 2 }}
                    >
                        Add Variation
                    </Button>
                </div>
            </Card>
        );
    }
}
